import React, { useState } from 'react'
import { useAuth } from '../../../contexts/AuthContext/AuthContext'
import { SignUpFormProps } from './types'
import { validateSignUpForm, getErrorMessage } from './helpers'
import { FirebaseError } from '../../../types/errors'
import {
  FormContainer,
  Title,
  Form,
  Input,
  Button,
  ErrorMessage,
  LinkButton,
  LegalLinks,
  LegalLink,
} from './styled'

const SignUpForm: React.FC<SignUpFormProps> = ({ onToggleMode }) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { signUp } = useAuth()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    const validation = validateSignUpForm(email, password, confirmPassword)
    if (!validation.isValid) {
      setError(validation.error || 'Invalid form data')
      return
    }

    setError('')
    setLoading(true)

    try {
      await signUp(email, password, displayName || undefined)
    } catch (err) {
      setError(getErrorMessage(err as FirebaseError))
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormContainer>
      <Title>Create Account</Title>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          placeholder="Display Name (optional)"
          value={displayName}
          onChange={e => setDisplayName(e.target.value)}
          disabled={loading}
        />
        <Input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          disabled={loading}
          required
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
          required
        />
        <Input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          disabled={loading}
          required
        />
        <Button type="submit" disabled={loading}>
          {loading ? 'Creating Account...' : 'Create Account'}
        </Button>
      </Form>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <LinkButton type="button" onClick={onToggleMode}>
        Already have an account? Sign in
      </LinkButton>
      <LegalLinks>
        <LegalLink href="/privacy">Privacy Policy</LegalLink>
        <span>•</span>
        <LegalLink href="/terms">Terms of Use</LegalLink>
      </LegalLinks>
    </FormContainer>
  )
}

export { SignUpForm }
